import React from "react";

import { IconProps } from "../../types/common";

const AttachmentIcon = ({
  width = "16",
  height = "16",
  style,
  className,
  fillClassName,
  fillColor = "#222324",
}: IconProps) => (
  <svg
    style={style}
    width={width}
    height={height}
    aria-hidden="true"
    viewBox="0 0 16 16"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill={fillColor!}
      className={fillClassName}
      d="M10.6663 4.49843V11.5518C10.6663 12.9451 9.64634 14.1851 8.25967 14.3184C6.66634 14.4718 5.33301 13.2251 5.33301 11.6651V3.4251C5.33301 2.55176 5.95967 1.75843 6.82634 1.67176C7.82634 1.57176 8.66634 2.35176 8.66634 3.33176V10.3318C8.66634 10.6984 8.36634 10.9984 7.99967 10.9984C7.63301 10.9984 7.33301 10.6984 7.33301 10.3318V4.49843C7.33301 4.2251 7.10634 3.99843 6.83301 3.99843C6.55967 3.99843 6.33301 4.2251 6.33301 4.49843V10.2384C6.33301 11.1118 6.95967 11.9051 7.82634 11.9918C8.82634 12.0918 9.66634 11.3118 9.66634 10.3318V3.4451C9.66634 2.05176 8.64634 0.811762 7.25967 0.678429C5.67301 0.525096 4.33301 1.77176 4.33301 3.33176V11.5118C4.33301 13.4251 5.73301 15.1384 7.63967 15.3184C9.83301 15.5184 11.6663 13.8118 11.6663 11.6651V4.49843C11.6663 4.2251 11.4397 3.99843 11.1663 3.99843C10.893 3.99843 10.6663 4.2251 10.6663 4.49843Z"
    />
  </svg>
);

export default AttachmentIcon;
